/**
 * Leaflet prototype patches to prevent null-reference errors during zoom animations.
 * These errors occur when layers receive zoom/animation events after being removed from the map.
 * Import this module after importing Leaflet to apply patches globally.
 */
import L from 'leaflet';

let patched = false;

export function patchLeaflet() {
  if (patched) return;
  patched = true;

  // --- Tooltip patches ---
  const origTooltipAnimateZoom = L.Tooltip.prototype._animateZoom;
  L.Tooltip.prototype._animateZoom = function (e) {
    if (!this._map) return;
    origTooltipAnimateZoom.call(this, e);
  };

  const origTooltipUpdatePosition = L.Tooltip.prototype._updatePosition;
  L.Tooltip.prototype._updatePosition = function () {
    if (!this._map) return;
    origTooltipUpdatePosition.call(this);
  };

  const origTooltipUpdate = L.Tooltip.prototype.update;
  L.Tooltip.prototype.update = function () {
    if (!this._map) return this;
    return origTooltipUpdate.call(this);
  };

  // --- Popup patches ---
  const origPopupAnimateZoom = L.Popup.prototype._animateZoom;
  L.Popup.prototype._animateZoom = function (e) {
    if (!this._map) return;
    origPopupAnimateZoom.call(this, e);
  };

  const origPopupUpdatePosition = L.Popup.prototype._updatePosition;
  L.Popup.prototype._updatePosition = function () {
    if (!this._map) return;
    origPopupUpdatePosition.call(this);
  };

  const origPopupUpdate = L.Popup.prototype.update;
  L.Popup.prototype.update = function () {
    if (!this._map) return this;
    return origPopupUpdate.call(this);
  };

  // --- GridLayer patches ---
  const wrap = (proto, method) => {
    const orig = proto[method];
    if (!orig) return;
    proto[method] = function (...args) {
      if (!this._map) return;
      try {
        return orig.apply(this, args);
      } catch (err) {
        if (!this._map) return; // map removed mid-execution
        throw err;
      }
    };
  };

  wrap(L.GridLayer.prototype, '_animateZoom');
  wrap(L.GridLayer.prototype, '_setView');
  wrap(L.GridLayer.prototype, '_updateLevels');
  wrap(L.GridLayer.prototype, '_onZoomEnd');
  wrap(L.GridLayer.prototype, '_update');
  wrap(L.GridLayer.prototype, '_resetView');
}
